import Actions from '../../odata/actions';

const actions = new Actions('keywordHistoryResult', 'keywordHistoryResults');

export default actions;
